export enum BinaryOperation {
    And,
    Or,
    None
}